import setModal from './set-modal'
import resetErrors from './reset-errors'

export default () => {
  return async (dispatch) => {
    dispatch(setModal(null))
    dispatch(resetErrors())
  }
}
